export default __webpack_public_path__ + "static/media/BgImage.97b74ab7.jpg";